"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Link = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = require("styled-components");
var styles_1 = require("./styles");
var EXTERNAL_PROPS = { rel: 'noopener nofollow', target: '_blank' };
var Link = function (_a) {
    var _b;
    var className = _a.className, href = _a.href, _c = _a.isExternal, isExternal = _c === void 0 ? false : _c, _d = _a.newTab, newTab = _d === void 0 ? true : _d, _e = _a.block, block = _e === void 0 ? false : _e, _f = _a.color, color = _f === void 0 ? 'BLUE_50' : _f, _g = _a.hoverColor, hoverColor = _g === void 0 ? 'BLUE_60' : _g, children = _a.children, ariaLabel = _a.ariaLabel, onClick = _a.onClick, onMouseEnter = _a.onMouseEnter, onMouseLeave = _a.onMouseLeave, rest = __rest(_a, ["className", "href", "isExternal", "newTab", "block", "color", "hoverColor", "children", "ariaLabel", "onClick", "onMouseEnter", "onMouseLeave"]);
    var theme = styled_components_1.useTheme();
    if (isExternal) {
        return (react_1.default.createElement(styles_1.ExternalLink, __assign({ "data-component-name": "Link" }, rest, { className: className, href: href, "$isExternal": isExternal, "$color": color, "$hoverColor": hoverColor, "aria-label": ariaLabel, onClick: onClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, "$block": block }, (newTab ? EXTERNAL_PROPS : {})), children));
    }
    return (react_1.default.createElement(styles_1.Wrapper, __assign({ "data-component-name": "Link" }, rest, { as: (_b = theme) === null || _b === void 0 ? void 0 : _b.LinkComponent, "aria-label": ariaLabel, href: href, onClick: onClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, className: className, "$color": color, "$hoverColor": hoverColor, "$block": block }), children));
};
exports.Link = Link;
exports.default = exports.Link;
